import { Alert } from '@mui/lab';
import styled from 'styled-components';

export const Banner = styled(Alert)`
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
`;
